import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FadvCheckboxCardComponent } from '@fa-switch-sharedservices/ng-elements';

@Component({
  selector: 'app-ala-carte-product',
  templateUrl: './ala-carte-product.component.html',
  styleUrls: ['./ala-carte-product.component.less']
})
export class ALaCarteProductComponent implements OnInit {

  @Input() product: any;
  @Input() hideDlProduct: boolean;
  @Input() formGroup: UntypedFormGroup;
  @Output() emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('checkBoxCard') checkBoxCard!: FadvCheckboxCardComponent;
  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() : void {
    this.checkBoxCard.checked = this.formGroup.controls[this.product.id.toString()].value;
    this.checkBoxCard.disabled = this.product.isDL && this.hideDlProduct;
    this.checkBoxCard.changed.subscribe(x => this.handleCheck()); 
  }

  ngOnDestroy() : void {
    this.checkBoxCard.changed.unsubscribe();
  }

  handleCheck() {
    this.emitter.emit(this.checkBoxCard.checked);
  }
}
